import { useTranslation } from "react-i18next";

export const ExampleCase = () => {
  const { t } = useTranslation();

  return (
    <section 
      id="example-case" 
      className="py-12 md:py-16 bg-stone-50"
      data-testid="example-case-section"
    >
      <div className="max-w-3xl mx-auto px-6">
        <h2 
          className="text-lg md:text-xl font-semibold text-[#1B4D3E] mb-2"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          {t('exampleCase.headline')}
        </h2>
        <p className="text-xs text-stone-500 mb-6">
          {t('exampleCase.disclaimer')}
        </p>

        <div className="bg-white rounded-lg border border-stone-200 divide-y divide-stone-100">
          <div className="p-4">
            <h3 className="text-sm font-medium text-stone-700 mb-1">
              {t('exampleCase.sections.situation.title')}
            </h3>
            <p className="text-sm text-stone-600">
              {t('exampleCase.sections.situation.text')}
            </p>
          </div>
          <div className="p-4">
            <h3 className="text-sm font-medium text-stone-700 mb-1">
              {t('exampleCase.sections.openPoints.title')}
            </h3>
            <p className="text-sm text-stone-600">
              {t('exampleCase.sections.openPoints.text')}
            </p>
          </div>
          <div className="p-4 bg-[#1B4D3E]/5">
            <h3 className="text-sm font-medium text-[#1B4D3E] mb-1">
              {t('exampleCase.sections.result.title')}
            </h3>
            <p className="text-sm text-stone-600">
              {t('exampleCase.sections.result.text')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
